import styled, { css } from "styled-components";

interface IContainer {
  marginTop?: number;
}

export const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.colors.surface.surfaceOutline};
  background-color: ${({theme}) => theme.colors.surface.surface};
  margin-top: ${({marginTop}) => marginTop || 0}px;
`;

export const Title = styled.div`
  padding-bottom: 12px;
  border-bottom: 1px solid ${({theme}) => theme.colors.surface.surfaceOutline};
  
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
`;

export const Description = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({theme}) => theme.colors.surface.onSurface};
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  .searchContainer {
    width: 100%;
    height: 42px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 5px;
    border: 1px solid ${({theme}) => theme.colors.surface.surfaceOutline};
    background-color: ${({theme}) => theme.colors.surface.surface};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  .emptyContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 43.5px 0;

    .emptyTitle {
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
      color: ${({theme}) => theme.colors.surface.onSurface};
    }

    .emptyText {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${({theme}) => theme.colors.surface.onSurfaceVariant};
      margin-top: 6px;
    }
  }
`;

interface IDivider {
  nottop?: boolean;
}

export const Divider = styled.div<IDivider>`
  height: 1px;
  width: 100%;
  background-color: ${({theme}) => theme.colors.surface.surfaceOutline};
  margin: 24px 0;

  ${({nottop}) => nottop && css`
    margin-top: 14px;
  `}
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  .saveBtn {
    display: flex;
    align-items: center;
  }

  .cancelBtn {
    margin-left: 6px;
  }
`;
